import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from "../../../design/dialog";
import { useInvitation } from "../../../contexts/InvitationContext";
import EmptyStateView from "../../EmptyStateView";
import { Table, TableBody, TableCell, TableRow } from "../../../design/table";
import { useMatter } from "../../../contexts/MatterContext";
import { Invitation } from "../../../models/Invitation";
import { Navbar, NavbarItem } from "../../../design/navbar";
import { Avatar } from "../../../design/avatar";
import InvitationDialog from "../InvitationDialog/InvitationDialog";
import { Subheading } from "../../../design/heading";

interface InvitationsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const InvitationsDialog: React.FC<InvitationsDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const { invitations, updateInvitation } = useInvitation();
  const [currentTab, setCurrentTab] = useState<Invitation["status"]>("pending");

  const filteredInvitations = invitations.filter(
    (invitation) => invitation.status === currentTab,
  );

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>Invitations</DialogTitle>
        <DialogDescription>
          <Navbar>
            <NavbarItem
              current={currentTab === "pending"}
              onClick={() => setCurrentTab("pending")}
            >
              Pending
            </NavbarItem>
            <NavbarItem
              current={currentTab === "accepted"}
              onClick={() => setCurrentTab("accepted")}
            >
              Accepted
            </NavbarItem>
            <NavbarItem
              current={currentTab === "declined"}
              onClick={() => setCurrentTab("declined")}
            >
              Declined
            </NavbarItem>
          </Navbar>
        </DialogDescription>
        <DialogBody>
          {filteredInvitations.length === 0 && (
            <EmptyStateView
              title="No invitations"
              message="You don't have any invitations yet."
            />
          )}
          {filteredInvitations.length > 0 && (
            <Table>
              <TableBody>
                {filteredInvitations.map((invitation) => (
                  <TableRow key={invitation._id}>
                    <TableCell className="flex items-center gap-2">
                      {invitation.user && (
                        <>
                          <Avatar
                            src={invitation.user.avatarUrl}
                            alt={invitation.user.name}
                            className="w-12 h-12"
                            initials={invitation.user.initials}
                          />
                          <Subheading>{invitation.user.name}</Subheading>
                        </>
                      )}
                      {!invitation.user && invitation.email}
                    </TableCell>
                    <TableCell className="text-right">
                      <InvitationDialog invitation={invitation} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </DialogBody>
        <DialogActions className="justify-between"></DialogActions>
      </Dialog>
    </>
  );
};

export default InvitationsDialog;
